/* ==========================================================================
   Araguaney · motor de pedido contra entrega
   Un solo archivo para todas las secciones ara-*:
     1. La cantidad compartida entre todos los selectores de pack de la página.
     2. Abrir el formulario de Releasit desde cualquier botón con data-ara-pedir.
     3. Marcar en el formulario la cantidad elegida, y rellenar su cuenta atrás.
     4. Los precios en bolívares a tasa BCV.
     5. La cuenta atrás de la oferta del día (<ara-cuenta>).
     6. La barra fija de compra (<ara-barra>).
     7. Entradas al aparecer en pantalla, el reflejo del botón y «al recargar, arriba».
   La configuración llega en window.AraguaneyConfig (snippet ara-head).
   ========================================================================== */
(function () {
  'use strict';
  if (window.Araguaney) return;

  var cfg = window.AraguaneyConfig || {};
  var doc = document;
  var html = doc.documentElement;
  var A = (window.Araguaney = { cfg: cfg, cantidad: null, pedido: null });
  var ofertas = String(cfg.ofertas || 'quantity_0,quantity_1,quantity_2')
    .split(',')
    .map(function (s) { return s.trim(); })
    .filter(Boolean);
  var DIA = 86400000;
  var VE = 4 * 3600000; /* Venezuela: UTC−4, sin horario de verano */

  function todos(sel, raiz) { return [].slice.call((raiz || doc).querySelectorAll(sel)); }
  function emitir(nombre, detalle) { doc.dispatchEvent(new CustomEvent(nombre, { detail: detalle })); }
  function dos(n) { return (n < 10 ? '0' : '') + n; }
  function alListo(fn) {
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  /* La próxima medianoche de Venezuela: la misma para todos, recargar no la cambia */
  A.finDelDia = function () { return Math.floor((Date.now() - VE) / DIA) * DIA + DIA + VE; };

  /* ── 1. Cantidad compartida ───────────────────────────────────────────────
     Todos los selectores de pack se mueven juntos y el botón abre el formulario con la elegida.
     Los textos que dependen de la cantidad llevan data-ara-segun-cantidad y data-ara-c1/2/3. */
  function pintarEtiquetas(n) {
    todos('[data-ara-segun-cantidad]').forEach(function (el) {
      if (el.closest('.is-loading')) return;
      var t = el.getAttribute('data-ara-c' + n);
      if (t != null && el.textContent !== t) el.textContent = t;
    });
  }
  A.setCantidad = function (n, origen) {
    n = Math.max(1, Math.min(ofertas.length || 3, Number(n) || 1));
    A.cantidad = n;
    pintarEtiquetas(n);
    emitir('ara:cantidad', { n: n, origen: origen || null });
  };

  class AraSelector extends HTMLElement {
    connectedCallback() {
      var self = this;
      this._cambio = function (e) {
        var r = e.target;
        if (r && r.type === 'radio' && self.contains(r)) A.setCantidad(r.value, self);
      };
      this._oir = function (e) {
        if (e.detail && e.detail.origen !== self) self.marcar(e.detail.n);
      };
      this.addEventListener('change', this._cambio);
      doc.addEventListener('ara:cantidad', this._oir);
      var propia = this.querySelector('input[type="radio"]:checked');
      /* El primero que llega manda; los demás se alinean. En el editor manda el que se está editando. */
      if (A.cantidad && !cfg.editor) this.marcar(A.cantidad);
      else if (propia) A.setCantidad(propia.value, this);
    }
    disconnectedCallback() {
      this.removeEventListener('change', this._cambio);
      doc.removeEventListener('ara:cantidad', this._oir);
    }
    marcar(n) {
      var r = this.querySelector('input[type="radio"][value="' + n + '"]');
      if (r && !r.checked) r.checked = true;
    }
  }
  if (!customElements.get('ara-selector')) customElements.define('ara-selector', AraSelector);

  /* ── 2. Abrir el formulario de Releasit ───────────────────────────────────
     Motor nuevo de Releasit (main-*.js): no reconoce botones propios. Releasit dibuja su botón real
     en el gancho <a href="/rsi-btn-hook"> de la sección de producto. Nuestro botón le «pasa el ratón»
     (así Releasit precarga el formulario) y después le hace clic por debajo.
     Verificado el 07/10/2026 en Viral Shop y el 14/10/2026 en Mercatto.
     Motor antiguo (window._rsi): lo resuelven las clases _rsi-… que llevan nuestros botones. */
  var reenviando = false;
  var ocupado = false;

  function botonNativo() {
    var lista = todos('#rsi_buy_now_button').filter(function (b) {
      /* Nunca el del carrito lateral: ese abre el formulario del carrito, no el del producto */
      return !b.closest('cart-drawer, #shopify-section-cart-drawer, [class*="drawer"]');
    });
    return lista.filter(function (b) { return b.closest('.ara-hook'); })[0]
      || lista.filter(function (b) { return b.closest('.ara-producto'); })[0]
      || lista.filter(function (b) { return b.classList.contains('rsi_floating'); })[0]
      || lista[0]
      || null;
  }
  function disparar(el, tipos) {
    tipos.forEach(function (t) {
      el.dispatchEvent(new MouseEvent(t, { bubbles: true, cancelable: true, view: window }));
    });
  }
  function precargar() {
    var b = botonNativo();
    if (!b) return false;
    /* El botón escondido no se anuncia al lector de pantalla ni recibe el tabulador: el nuestro lo sustituye */
    if (b.closest('.ara-hook, .ara-producto')) {
      b.setAttribute('tabindex', '-1');
      b.setAttribute('aria-hidden', 'true');
    }
    disparar(b, ['pointerover', 'mouseover', 'pointerenter', 'mouseenter']);
    return true;
  }
  function dialogo() { return doc.querySelector('dialog._rsi_main_form_dialog_element'); }
  function formularioAbierto() { var d = dialogo(); return !!(d && d.open); }
  A.formularioAbierto = formularioAbierto;

  function cargando(btn, si) {
    if (!btn) return;
    var etiqueta = btn.querySelector('[data-ara-label]');
    if (si) {
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      if (etiqueta) {
        etiqueta.setAttribute('data-ara-antes', etiqueta.textContent);
        etiqueta.textContent = cfg.cargando || 'Abriendo tu pedido…';
      }
    } else {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      if (etiqueta && etiqueta.hasAttribute('data-ara-antes')) {
        etiqueta.textContent = etiqueta.getAttribute('data-ara-antes');
        etiqueta.removeAttribute('data-ara-antes');
      }
      if (A.cantidad) pintarEtiquetas(A.cantidad);
    }
  }

  /* Sin Releasit (o si no aparece): directo al pago de Shopify con la cantidad elegida */
  function irAlPago(btn) {
    var caja = (btn && btn.closest('[data-ara-variante]')) || doc.querySelector('[data-ara-variante]');
    var id = caja && caja.getAttribute('data-ara-variante');
    if (!id) return;
    window.location.href = '/cart/' + id + ':' + (A.pedido || A.cantidad || 1);
  }

  /* Releasit tarda ~1 s en abrir porque antes mete el producto en el carrito; eso no se acorta.
     Mientras tanto el botón dice que está abriendo, para que nadie pulse dos veces. Se hace clic cuando
     el botón nativo está activo y solo se reintenta si Releasit no lo aceptó (cuando lo acepta, su botón
     se desactiva enseguida: así el producto nunca entra dos veces al carrito). */
  function abrirReleasit(btn) {
    if (ocupado) return;
    ocupado = true;
    var inicio = Date.now();
    cargando(btn, true);

    function fin() { ocupado = false; cargando(btn, false); }
    function esperar(b, libre) {
      if (formularioAbierto() || Date.now() - inicio > 9000) return fin();
      if (!b.disabled && !libre) libre = Date.now();
      if (libre && Date.now() - libre > 400) return fin();
      setTimeout(function () { esperar(b, libre); }, 30);
    }
    (function intento() {
      if (formularioAbierto()) return fin();
      var b = botonNativo();
      if (!b) {
        /* Releasit no apareció: no se deja al cliente sin comprar */
        if (Date.now() - inicio > 5000) { fin(); return irAlPago(btn); }
        return setTimeout(intento, 60);
      }
      if (Date.now() - inicio > 9000) return fin();
      if (b.disabled) return setTimeout(intento, 30);
      precargar();
      reenviando = true;
      disparar(b, ['pointerdown', 'mousedown', 'pointerup', 'mouseup']);
      b.click();
      reenviando = false;
      setTimeout(function () {
        if (formularioAbierto() || b.disabled) return esperar(b, 0);
        intento();
      }, 60);
    })();
  }

  /* En fase de captura de window, para adelantarse a Releasit */
  window.addEventListener('click', function (e) {
    if (reenviando || !e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-ara-pedir]');
    if (!btn) return;
    var n = btn.getAttribute('data-ara-cantidad');
    if (n) A.setCantidad(n, btn);
    A.pedido = A.cantidad || 1;
    if (!cfg.releasit) {
      e.preventDefault();
      irAlPago(btn);
      return;
    }
    if (window._rsi) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    abrirReleasit(btn);
  }, true);

  /* Precarga: en cuanto aparece el botón nativo, y otra vez al acercarse a uno nuestro */
  function precargarSiHace() { if (cfg.releasit && !window._rsi) precargar(); }
  ['pointerover', 'touchstart', 'focusin'].forEach(function (t) {
    doc.addEventListener(t, function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-ara-pedir]')) precargarSiHace();
    }, { passive: true });
  });
  (function esperarNativo(n) {
    if (!cfg.releasit || window._rsi) return;
    if (!precargar() && n < 40) setTimeout(function () { esperarNativo(n + 1); }, 500);
  })(0);

  /* ── 3. El formulario abierto: la cantidad elegida y su cuenta atrás ──────
     Las ofertas aparecen un instante después de abrirse y Releasit tarda ~1,2 s en aplicarla: si a los
     2,5 s no quedó, se marca otra vez, salvo que el cliente ya haya tocado el formulario. */
  function marcarOferta(d) {
    var n = A.pedido || A.cantidad;
    if (!n) return; /* La página no tiene selector de pack: se respeta lo que traiga Releasit */
    var quiero = ofertas[n - 1] || ofertas[0];
    var inicio = Date.now();
    var cerrado = false;
    d.addEventListener('close', function () { cerrado = true; }, { once: true });
    (function buscar() {
      if (!d.open || cerrado) return;
      var r = d.querySelector('input[name="quantity_offer"][value="' + quiero + '"]');
      if (!r) { if (Date.now() - inicio < 8000) setTimeout(buscar, 80); return; }
      if (!r.checked) r.click();
      var tocado = false;
      d.addEventListener('pointerdown', function () { tocado = true; }, { capture: true, once: true });
      setTimeout(function () {
        if (cerrado || tocado || !d.open) return;
        var c = d.querySelector('input[name="quantity_offer"]:checked');
        if (!c || c.value !== quiero) {
          var r2 = d.querySelector('input[name="quantity_offer"][value="' + quiero + '"]');
          if (r2) r2.click();
        }
      }, 2500);
    })();
  }

  /* El texto del formulario trae <span id="timer-demo">: se rellena con lo que falta para la medianoche
     de Venezuela, la misma hora a la que termina la oferta de hoy de la landing */
  var reloj = null;
  function relojFormulario() {
    if (!cfg.cuentaFormulario || reloj) return;
    function tic() {
      var d = dialogo();
      if (!d || !d.open) { clearInterval(reloj); reloj = null; return; }
      var t = Math.max(0, Math.floor((A.finDelDia() - Date.now()) / 1000));
      var v = dos(Math.floor(t / 3600)) + ':' + dos(Math.floor((t % 3600) / 60)) + ':' + dos(t % 60);
      todos('#timer-demo', d).forEach(function (el) { if (el.textContent !== v) el.textContent = v; });
    }
    tic();
    reloj = setInterval(tic, 500);
  }

  var estabaAbierto = false;
  new MutationObserver(function () {
    var d = dialogo();
    var ahora = !!(d && d.open);
    if (ahora === estabaAbierto) return;
    estabaAbierto = ahora;
    if (ahora) { marcarOferta(d); relojFormulario(); }
    else A.pedido = null;
    emitir('ara:formulario', { abierto: ahora });
  }).observe(html, { subtree: true, attributes: true, attributeFilter: ['open'] });

  /* ── 4. Precios en bolívares a tasa BCV ───────────────────────────────────
     Misma fuente y misma cuenta que el sistema de pedidos (services/orders.ts → bsAmount): tasa con 2
     decimales y bolívares redondeados hacia arriba. Así el monto de la página es el que se registra.
     Si la fuente falla se usa la última tasa guardada en el teléfono; si es más vieja que «días», los
     bolívares no salen: nunca un número viejo como si fuera de hoy. */
  var bs = cfg.bs || {};
  var CLAVE = 'ara:tasa-bcv';
  var tasa = null;

  function bolivares(centimosUsd, t) {
    var bruto = Math.round((centimosUsd / 100) * t * 100) / 100;
    var red = Number(bs.redondeo) || 0;
    return red > 0 ? Math.ceil(bruto / red) * red : bruto;
  }
  /* 35100 → "35.100"; con decimales, 35017,2 → "35.017,20" (formato venezolano, sin depender del navegador) */
  function miles(n, dec) {
    var p = n.toFixed(dec).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return p.join(',');
  }
  A.formatoBs = function (centimosUsd) {
    if (!tasa) return '';
    return 'Bs ' + miles(bolivares(centimosUsd, tasa.tasa), Number(bs.redondeo) > 0 ? 0 : 2);
  };
  function fechaCorta(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
    return m ? m[3] + '/' + m[2] : '';
  }
  function vieja(t) {
    if (!t || !(t.tasa > 0)) return true;
    if (t.manual) return false;
    var f = Date.parse(t.fecha || '');
    if (isNaN(f)) f = t.guardada || 0;
    return Date.now() - f > (Number(bs.dias) || 4) * DIA;
  }
  A.pintarBs = function (raiz) {
    var cajas = todos('[data-ara-bs-caja]', raiz);
    if (!tasa) {
      cajas.forEach(function (c) { if (c.classList.contains('is-sin-tasa')) c.hidden = true; });
      return;
    }
    todos('[data-ara-bs]', raiz).forEach(function (el) {
      var c = Number(el.getAttribute('data-ara-bs'));
      if (c > 0) {
        var v = A.formatoBs(c);
        if (el.textContent !== v) el.textContent = v;
      }
    });
    todos('[data-ara-bs-tasa]', raiz).forEach(function (el) {
      var f = fechaCorta(tasa.fecha);
      el.textContent = 'Tasa BCV ' + miles(tasa.tasa, 2) + (f ? ' del ' + f : '');
    });
    cajas.forEach(function (c) { c.hidden = false; c.classList.remove('is-cargando'); c.classList.add('is-lista'); });
  };
  function usarTasa(t) {
    tasa = t;
    A.tasaBCV = t;
    alListo(function () { A.pintarBs(); });
    emitir('ara:tasa', t);
  }
  function sinTasa() {
    tasa = null;
    alListo(function () {
      todos('[data-ara-bs-caja]').forEach(function (c) { c.hidden = true; });
      todos('[data-ara-bs]').forEach(function (el) { el.textContent = ''; });
    });
  }
  function pedirTasa() {
    if (bs.mostrar === false) return;
    if (Number(bs.manual) > 0) { usarTasa({ tasa: Number(bs.manual), fecha: '', manual: true }); return; }
    var guardada = null;
    try { guardada = JSON.parse(localStorage.getItem(CLAVE) || localStorage.getItem('ms:tasa-bcv') || 'null'); } catch (e) {}
    if (guardada && !vieja(guardada)) usarTasa(guardada);
    var ctrl = 'AbortController' in window ? new AbortController() : null;
    var corte = setTimeout(function () { if (ctrl) ctrl.abort(); }, 8000);
    fetch(bs.fuente || 'https://ve.dolarapi.com/v1/dolares/oficial', { cache: 'no-store', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (j) {
        clearTimeout(corte);
        var t = { tasa: Math.round(Number(j && j.promedio) * 100) / 100, fecha: j && j.fechaActualizacion, guardada: Date.now() };
        if (vieja(t)) { if (!tasa) sinTasa(); return; }
        try { localStorage.setItem(CLAVE, JSON.stringify(t)); } catch (e) {}
        usarTasa(t);
      })
      .catch(function () { clearTimeout(corte); if (!tasa) sinTasa(); });
  }
  /* Solo se pide la tasa si la página tiene algún monto en bolívares */
  alListo(function () { if (doc.querySelector('[data-ara-bs], [data-ara-bs-caja]')) pedirTasa(); });

  /* ── 5. Cuenta atrás de la oferta ─────────────────────────────────────────
     Cuenta hacia una hora real: la medianoche de Venezuela (modo «dia») o una fecha fija (modo «fecha»,
     y al llegar la cuenta desaparece). Recargar no la reinicia. */
  class AraCuenta extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.modo = this.getAttribute('data-modo') === 'fecha' ? 'fecha' : 'dia';
      this.urgente = Math.max(0, Number(this.getAttribute('data-urgente')) || 0) * 60000;
      this.caja = this.closest('[data-ara-cuenta-caja]') || this;
      this.ultimo = {};
      this.fin = this.calcularFin();
      if (this.fin === null) { this.caja.hidden = true; return; }
      this.visible = true;
      this._volver = function () { self.reanudar(); };
      doc.addEventListener('visibilitychange', this._volver);
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (e) {
          self.visible = e[0].isIntersecting;
          if (self.visible) self.reanudar();
        });
        this.io.observe(this);
      }
      this.reanudar();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.io) this.io.disconnect();
      doc.removeEventListener('visibilitychange', this._volver);
    }
    calcularFin() {
      if (this.modo === 'fecha') {
        var f = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(this.getAttribute('data-fin') || '');
        return f ? Date.UTC(+f[1], +f[2] - 1, +f[3], +f[4], +f[5]) + VE : null;
      }
      return A.finDelDia();
    }
    poner(u, v) {
      if (this.ultimo[u] === v) return;
      var celda = this.querySelector('[data-u="' + u + '"] .ara-cuenta__v');
      if (!celda) return;
      celda.textContent = v;
      /* La cifra que cambia baja un poco al entrar, como en un marcador */
      if (this.ultimo[u] !== undefined && this.visible && html.classList.contains('ara-anima') && celda.animate) {
        celda.animate([{ transform: 'translateY(-38%)', opacity: 0.15 }, { transform: 'translateY(0)', opacity: 1 }],
          { duration: 260, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
      }
      this.ultimo[u] = v;
    }
    tic() {
      var falta = this.fin - Date.now();
      if (falta <= 0) {
        if (this.modo === 'fecha') { this.caja.hidden = true; clearTimeout(this.timer); return false; }
        this.fin = this.calcularFin();
        falta = this.fin - Date.now();
      }
      var t = Math.floor(falta / 1000);
      var d = Math.floor(t / 86400);
      var dias = this.querySelector('[data-u="d"]');
      var sep = this.querySelector('[data-u="dsep"]');
      if (dias) dias.hidden = d < 1;
      if (sep) sep.hidden = d < 1;
      if (d > 0) this.poner('d', dos(d));
      this.poner('h', dos(Math.floor((t % 86400) / 3600)));
      this.poner('m', dos(Math.floor((t % 3600) / 60)));
      this.poner('s', dos(t % 60));
      this.classList.toggle('is-urgente', falta <= this.urgente);
      return true;
    }
    reanudar() {
      var self = this;
      clearTimeout(this.timer);
      (function bucle() {
        if (!self.tic()) return;
        if (!self.visible || doc.hidden) return;
        /* Cada tic se alinea con el cambio de segundo del reloj y sale de la hora real */
        self.timer = setTimeout(bucle, 1000 - (Date.now() % 1000) + 15);
      })();
    }
  }
  if (!customElements.get('ara-cuenta')) customElements.define('ara-cuenta', AraCuenta);

  /* ── 6. Barra fija de compra ──────────────────────────────────────────────
     Aparece cuando el botón principal ya quedó por encima de la pantalla, y se esconde si hay otro
     botón de pedido a la vista (para no repetirlo) o si el formulario está abierto. */
  class AraBarra extends HTMLElement {
    connectedCallback() {
      if (this.parentNode !== doc.body) {
        /* Sacarla del contenedor de la sección: así ningún overflow ni transform del tema la recorta.
           En el editor la sección se vuelve a pintar: se quita la barra anterior. */
        todos('ara-barra').forEach(function (b) { if (b !== this && b.parentNode === doc.body) b.remove(); }, this);
        doc.body.appendChild(this);
        return;
      }
      var self = this;
      this.on = false;
      this.principalArriba = false;
      this.visibles = new Set();
      doc.body.classList.add('ara-con-barra');
      this.principal = doc.querySelector('[data-ara-principal]')
        || todos('[data-ara-pedir]').filter(function (b) { return !self.contains(b); })[0]
        || null;
      this.io = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          if (en.target === self.principal) {
            self.principalArriba = !en.isIntersecting && en.boundingClientRect.bottom < 0;
          } else if (en.isIntersecting) self.visibles.add(en.target);
          else self.visibles.delete(en.target);
        });
        self.decidir();
      });
      if (this.principal) this.io.observe(this.principal);
      todos('[data-ara-pedir]').forEach(function (b) {
        if (b !== self.principal && !self.contains(b)) self.io.observe(b);
      });
      this._form = function () { self.decidir(); };
      doc.addEventListener('ara:formulario', this._form);
      this.decidir();
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      doc.removeEventListener('ara:formulario', this._form);
      if (!doc.querySelector('ara-barra')) {
        doc.body.classList.remove('ara-con-barra');
        html.classList.remove('ara-barra-visible');
      }
    }
    decidir() {
      var ver = !!this.principal && this.principalArriba && this.visibles.size === 0 && !formularioAbierto();
      if (ver === this.on) return;
      this.on = ver;
      this.classList.toggle('is-on', ver);
      html.classList.toggle('ara-barra-visible', ver);
    }
  }
  if (!customElements.get('ara-barra')) customElements.define('ara-barra', AraBarra);

  /* ── 7. Entradas, reflejo del botón, «al recargar, arriba» ────────────────── */
  var ioEntrada = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      ioEntrada.unobserve(en.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;

  /* El reflejo del botón solo corre mientras el botón está en pantalla */
  var ioBrillo = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (en) { en.target.classList.toggle('is-visible', en.isIntersecting); });
  }, { threshold: 0.6 }) : null;

  A.iniciar = function (raiz) {
    raiz = raiz || doc;
    todos('[data-ara-revelar]', raiz).forEach(function (el) {
      if (ioEntrada && !el.classList.contains('is-in')) ioEntrada.observe(el);
      else el.classList.add('is-in');
    });
    if (ioBrillo) todos('[data-ara-brillo]', raiz).forEach(function (el) { ioBrillo.observe(el); });
    if (tasa) A.pintarBs(raiz);
    if (A.cantidad) pintarEtiquetas(A.cantidad);
  };
  alListo(function () { A.iniciar(doc); });

  /* En el editor del tema, cada sección que se vuelve a pintar se inicia de nuevo */
  doc.addEventListener('shopify:section:load', function (e) {
    A.iniciar(e.target);
    if (!tasa && e.target.querySelector && e.target.querySelector('[data-ara-bs]')) pedirTasa();
  });
  /* La barra fija vive fuera de su sección: si se borra la sección en el editor, se va con ella */
  doc.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (id) todos('ara-barra[data-ara-seccion="' + id + '"]').forEach(function (b) { b.remove(); });
  });

  /* Al recargar, la página empieza arriba: el navegador recuerda la posición y la landing es una historia
     que se lee desde el principio. Si el cliente ya movió la página, no se toca. */
  if (cfg.recargarArriba && !cfg.editor && !location.hash) {
    try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
    var movio = false;
    ['touchstart', 'wheel', 'keydown', 'mousedown'].forEach(function (t) {
      window.addEventListener(t, function () { movio = true; }, { passive: true, once: true });
    });
    var arriba = function () { if (!movio) window.scrollTo(0, 0); };
    arriba();
    alListo(arriba);
    window.addEventListener('pageshow', function (e) { if (!e.persisted) arriba(); });
  }
})();
